import { collection, doc, getDocs, query, setDoc, Timestamp, where } from 'firebase/firestore';
import { db } from '../../../config';
import { DictionaryRow } from '../../../../../types/dictionary';

interface SaveDictionaryHistoryParams {
  dictionaryId: string;
  queryText: string;
  matchedValue: string;
  matchedRow: DictionaryRow;
  searchItemId: string;
  searchItemLabel: string;
}

// 辞書変換の変換履歴を保存する。
// 同じ query_text の履歴が既にあれば上書きし、無ければ新規作成する（読取値ごとに 1 件）。
export const saveDictionaryHistory = async (params: SaveDictionaryHistoryParams): Promise<void> => {
  const historiesRef = collection(db, 'dictionaries', params.dictionaryId, 'conversion_histories');

  // 既存の同一 query_text を検索（あれば上書き）
  const existingSnap = await getDocs(
    query(historiesRef, where('query_text', '==', params.queryText)),
  );
  const targetRef = existingSnap.empty ? doc(historiesRef) : existingSnap.docs[0].ref;

  const now = Timestamp.now();
  await setDoc(
    targetRef,
    {
      query_text: params.queryText,
      matched_value: params.matchedValue,
      matched_row: params.matchedRow,
      search_item_id: params.searchItemId,
      search_item_label: params.searchItemLabel,
      created_at: existingSnap.empty ? now : (existingSnap.docs[0].data().created_at ?? now),
      updated_at: now,
    },
    { merge: true },
  );
};
